// Glossary script

const indexEl = document.getElementsByClassName("glossary-index")[0];
const contentEl = document.getElementsByClassName("glossary-content")[0];
const marginBottom = 45; // static margin of term element

// Get Y coordinate of content part
const mainTopOffset = getOffsetTop(contentEl);

// call function on scroll if glossary element present
if (document.getElementsByClassName("glossary").length > 0) {
  window.onscroll = function () { scrollFunction() };
}

// on scroll change DOM for glossary index and content
function scrollFunction() {
  // case 1: when scroll on glossary part begins and scrolling over the content part
  if ((document.documentElement.scrollTop > mainTopOffset && document.body.scrollTop < (contentEl.offsetHeight - marginBottom))) {
    indexEl.classList.add("fixed-desktop");
    indexEl.classList.remove("stick-left");
    // change position  
    contentEl.classList.add("offset-1");
    contentEl.classList.add("offset-sm-0");
  } else {
    //case default
    indexEl.classList.remove("fixed-desktop");
    contentEl.classList.remove("offset-1");
    contentEl.classList.remove("offset-sm-0");
  }
  // case 2: when glossary part is scrolled over
  if (document.documentElement.scrollTop >= (contentEl.offsetHeight - marginBottom)) {
    indexEl.classList.remove("fixed-desktop");
    indexEl.classList.add("stick-left");
  } 
}

// returns top offset of an element
function getOffsetTop(element) {
  let offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
}
